(function () {
  if (window.__cartUiInit) return;
  window.__cartUiInit = true;

  function updateAllCartBadges(count) {
    document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
      const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
      if (visibleSpan) {
        visibleSpan.textContent = count < 100 ? count : "";
      }
      bubble.classList.toggle("cart-count-bubble--empty", count === 0);
    });
  }

  function refreshCartBadge() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => updateAllCartBadges(cart.item_count))
      .catch((error) => console.error("cart badge refresh failed:", error));
  }

  function showCartToast(message) {
    const toast = document.getElementById("cart-toast");
    if (!toast) return;

    if (message) {
      const text = toast.querySelector(".cart-toast__text");
      if (text) text.textContent = message;
    }

    toast.classList.add("is-visible");
    window.clearTimeout(toast.hideTimeout);
    toast.hideTimeout = window.setTimeout(() => {
      toast.classList.remove("is-visible");
    }, 2600);
  }

  document.body.addEventListener("cart:refresh", refreshCartBadge);
  document.body.addEventListener("cart:item-added", (event) => {
    showCartToast(event.detail && event.detail.message);
  });
})();
